import type { IDealGroup } from '@/Interfaces/Beeswax/DealGroup.interface';
import type { IControlOption } from '@/Interfaces/ControlOption.interface';

export default class DealGroupsService {
  public static dealGroupsToControlOptions(dealGroups: IDealGroup[]): IControlOption[] {
    if (!dealGroups?.length) {
      return [];
    }
    return dealGroups
      .map(deal => ({ value: deal.id, label: deal.name }))
      .sort((a, b) => a.label?.localeCompare(b?.label));
  }
}
